module.exports = __webpack_public_path__ + "img/kevin.765eb82.webp";